import { render, staticRenderFns } from "./tabPane.vue?vue&type=template&id=21ca3b5d&scoped=true"
import script from "./tabPane.vue?vue&type=script&lang=js"
export * from "./tabPane.vue?vue&type=script&lang=js"
import style0 from "./tabPane.vue?vue&type=style&index=0&id=21ca3b5d&prod&lang=scss&scoped=true"
import style1 from "./tabPane.vue?vue&type=style&index=1&id=21ca3b5d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ca3b5d",
  null
  
)

export default component.exports